<div>

  <p-table #list [columns]="cols" [value]="listData" [lazy]="true" (onLazyLoad)="loadListLazy($event)" [paginator]="true"
           [rows]="15" [totalRecords]="totalRecords" [loading]="loading" [globalFilterFields]="['Accession']">

    <ng-template pTemplate="caption" [style]="{'height':'30px !important'}">
      <div style="height: 30px; width: 100%">
        <span class="float-left">Requisition Test List</span>
        <div class="float-right" style="margin-left: 20px;">
          <a (click)="loadListLazy(null)" class="text-white" style="font-size:24px; cursor:pointer; margin-left: 5px;" title="Refresh List"><i class="fa fa-refresh" [ngClass]="{'fa-spin':loading}"></i> </a>
        </div>
        <div class="float-right">
          <input pInputText type="text" (keypress)="handleSearchKey($event, list)" placeholder="Global Search" />
        </div>
      </div>
    </ng-template>



    <ng-template pTemplate="header" let-columns>
      <tr>
        <th style="width:50px">&nbsp;</th>
        <th *ngFor="let col of columns" [pSortableColumn]="col.field">
          {{col.header}}
          <p-sortIcon [field]="col.field"></p-sortIcon>
        </th>
      </tr>

    </ng-template>
    <ng-template pTemplate="body" let-rowData let-columns="columns">
      <tr>
        <td>
          <a style="cursor:pointer" (click)="rowData['showDetail'] = !rowData['showDetail'];"><i class="fa fa-eye"></i></a>
        </td>
        <td *ngFor="let col of columns" [ngSwitch]="col.field">
          <span *ngSwitchDefault>{{rowData[col.field]}}</span>
        </td>
      </tr>
      <tr *ngIf="rowData['showDetail'] == true" [@inOutAnimation]>
        <td colspan="10" style="background-color: lightgray; padding: 15px">
          <limsim-add-results requisitionTestId="{{rowData['RequisitionTestId']}}"></limsim-add-results>
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>
<p-toast></p-toast>
